(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceDialogController', AdvertisingSourceDialogController);

    AdvertisingSourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AdvertisingSource', 'CloudPBX'];

    function AdvertisingSourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AdvertisingSource, CloudPBX) {
        var vm = this;

        vm.advertisingSource = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        vm.uploadPhoneFormats = [
            "+X(XXX)XXX-XX-XX",
            "X(XXX)XXX-XX-XX",
            "8(XXX)XXX-XX-XX",
             "(XXX)XXX-XX-XX",
           "+X-XXX-XXX-XX-XX",
            "X-XXX-XXX-XX-XX",
            "8-XXX-XXX-XX-XX",
              "XXX-XXX-XX-XX",
               "8XXX-XXXXXXX",
                   "CIANFEED"
        ];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.advertisingSource.id !== null) {
                AdvertisingSource.update(vm.advertisingSource, onSaveSuccess, onSaveError);
            } else {
                AdvertisingSource.save(vm.advertisingSource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:advertisingSourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
